import { navigate } from 'gatsby';
import * as React from 'react'

export default { navigate, React }